export { resetSpinner } from "./state/actions";
export { SpinnerModule } from "./spinner.module";